import type { GTableBoxBorderBase, GTableBoxPaddingBase } from '~/presentation/ui';

import { useGCampaignTableContext } from '../contexts';
import { BlockStack, Box } from '@shopify/polaris';

export interface CellProps {
  children: React.ReactNode;
  index: number;
  padding?: GTableBoxPaddingBase;
  borders?: GTableBoxBorderBase;
  minHeight?: string;
}
export const Cell: React.FC<CellProps> = ({
  children,
  index,
  padding,
  borders,
  minHeight = '100%',
}) => {
  const { alignments, getHighlightBgColumn } = useGCampaignTableContext();

  const assignment = alignments[index] ?? 'start';
  const highlightBg = getHighlightBgColumn(index);

  return (
    <div className={`GCampaignTable-Cell`}>
      <Box {...padding} {...borders} {...highlightBg} width="100%" minHeight={minHeight}>
        <BlockStack inlineAlign={assignment} align="center">
          {children}
        </BlockStack>
      </Box>
    </div>
  );
};
